import UserInfoForm from './UserInfoForm';

export default UserInfoForm;
